<template>
  <div class="product-detail-bottom-bar">
    <slot name="top">
      <!-- page-guide-bar -->
      <vip-inform-bar v-if="pageGuideInfo && pageGuideInfo.position === 'bottom'"
                      :button="pageGuideInfo.button"
                      :tip="pageGuideInfo.tip"
                      :url="pageGuideInfo.url"
                      :icon="pageGuideInfo.icon"
                      :background="pageGuideInfo.background"
                      v-ym-report:MARKETING_VIP_AD_PRODUCT_DETAIL_CLICK=""
      />
      <!-- benefit-bar -->
      <benefit-bar v-if="benefitBar && benefitBar.show"
                   :benefit="benefitBar"
      />
    </slot>

    <div class="bottom-container"
         :class="{ 'small-height': component === 'CanJoinBar' }"
    >
      <slot name="left"><!-- 存放试听 --></slot>

      <div class="bottom-container-content">
        <!-- show team when join groupBuy -->
        <show-my-team-bar v-if="myTeamId > 0"
                          :id="myTeamId"
                          :type="myTeamBarType"
        />
        <slot v-else>
          <component :is="component"
                     :sell="sell"
                     :product="product"
                     :start-hint="startHint"
                     :render-price="renderPrice"
                     :action-bar="actionBar"
                     :origin-price="product.price"
                     :modal-guide-info="modalGuideInfo"
                     :row-btn-round="rowBtnRound"
                     :show-contact-us="showContactUs"
          />
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import VipInformBar from '@/pages/Vip/components/ProductDetailVipInformBar';
  import BenefitBar from '@/components/BenefitBar';
  import ShowMyTeamBar from '@/components/ProductDetailBottom/ShowMyTeamBar';
  import UnstartBar from '@/components/ProductDetailBottom/UnstartBar';
  import CanJoinBar from '@/components/ProductDetailBottom/CanJoinBar';
  import DisabledBar from '@/components/ProductDetailBottom/DisabledBar';
  import validator from '@/utils/validator';
  import { upperCaseFirst } from '@/utils';

  export default {
    name: 'ProductDetailBottomBar',
    components: {
      VipInformBar,
      BenefitBar,
      ShowMyTeamBar,
      UnstartBar,
      CanJoinBar,
      DisabledBar,
    },
    props: {
      showContactUs: {
        type: Boolean,
        default: true,
      },
      benefitBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      sell: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: true,
      },
      renderPrice: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      actionBar: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      myTeamId: {
        type: Number,
        default: 0,
      },
      myTeamBarType: String,
      startHint: {
        type: String,
        default: '开售',
      },
      pageGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      modalGuideInfo: {
        validator(val) {
          return validator.isObject(val);
        },
      },
      rowBtnRound: Boolean,
    },
    computed: {
      component() {
        const { sell } = this;
        const { status } = sell;
        switch (status) {
          case 'unstart':
          case 'canJoin':
            return `${upperCaseFirst(status)}Bar`;
          case 'canExchange':
            return 'CanJoinBar';
          default:
            return 'DisabledBar';
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-bottom-bar {
    min-height: 120px;
    flex: 1;
    align-self: stretch;
  }

  .bottom-container {
    height: 100%;
    display: flex;
    flex: 1;
    &.small-height {
      box-sizing: border-box;
      margin-top: 10px;
      padding: 0 @size-base;
      height: @bottom-bar-height;
      /deep/ .product-detail-bottom-bar-left-slot {
        margin-left: -@size-base;
      }
    }

    &-content {
      display: flex;
      flex: 1;
      z-index: @z-index-medium;
    }
  }
</style>
